import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {Table2Component} from "../../../../../../common/components/table2";
import {Table} from "../../../../../../common/interfaces/table.interface";
import {Router} from "@angular/router";

@Component({
    selector: "section-adjust-transactions",
    template: `
        <h1 class="container-heading">Adjust transactions</h1>
        <mat-card>
            <mat-card-content>
                <common-table2 *ngIf="listTable" [settings]="listTable"></common-table2>
            </mat-card-content>
        </mat-card>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdjustTransactionsComponent implements Base.IComponent, OnInit {

    public readonly state: Base.IState;

    @ViewChild(Table2Component, {static: false})

    public tableRef: Table2Component;

    public listTable: Table.ISettings;

    public constructor(
        private router: Router,
        private changeDetectorRef: ChangeDetectorRef
    ) {
    }

    /**
     * Prepare list/table
     * @returns {void}
     */
     private prepareList(): void {
        const actions: Table.IAction[] = [
            {
                name: "view",
                title: "View",
                click: (row: any): void => {
                    this.router.navigate([
                        "partner",
                        row.partner.slug,
                        "adjust-transactions",
                        "view",
                        "id",
                        row.id,
                        "type",
                        "adjust"
                    ]);
                }
            }];

        const columns: Table.ICol[] = [
            {
                data: "ref",
                title: "Ref",
                sortable: false
            },
            {
                data: "status.name",
                name: "status.name",
                title: "Status",
                sortable: false
            },
            {
                data: "service_level.name",
                name: "ServiceLevel.name",
                title: "Service level",
                sortable: false
            },
            {
                data: "service_level.order_type.display_name",
                name: "ServiceLevel.orderType.display_name",
                title: "Order type",
                sortable: false
            },
            {
                data: "service_level.shipping_mode.display_name",
                name: "ServiceLevel.shippingMode.display_name",
                title: "Shipping mode",
                sortable: false
            }
        ];

        if (this.state.section === "admin") {
            columns.unshift({
                data: "partner.full_name",
                name: "Partner.full_name",
                title: "Partner",
                sortable: false
            });
        }

        this.listTable = {
            table_id: "JHydmj4dfii",
            actions,
            api: {
                url: ["order"],
                query: {
                    property_items_status: "exception"
                }
            },

            columns,
            export: {
                file_name: "adjust transactions"
            }
        };
        this.changeDetectorRef.markForCheck();
    }


    public ngOnInit(): void {
        this.prepareList();
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "adjust-transactions",
            actions: {
                "browse": ["read_warehouse_transactions"]
            }
        };
    }

}
